import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight, UserRound, AlertCircle } from "lucide-react";
import Layout from "../components/Layout";
import StepIndicator from "../components/StepIndicator";
import BackButton from "../components/BackButton";
import Loading from "../components/Loading";
import { listarProfissionais } from "../lib/api";
import { getBooking, setBooking } from "../lib/bookingState";

const STEPS = ["CPF", "Tipo", "Especialidade", "Profissional", "Horario", "Confirmar"];

export default function AgendarProfissional() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  const booking = getBooking();

  useEffect(() => {
    if (!booking.especialidade_id) {
      navigate("/agendar/especialidade", { replace: true });
      return;
    }

    listarProfissionais(booking.especialidade_id, {
		patientId: booking.patient_id,
	})
      .then(setItems)
      .catch(() => setItems([]));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleSelect(p) {
    setBooking({
      profissional_id: p.id,
      profissional_nome: p.nome,
      profissional_crm: p.crm || "",
      data_hora: undefined,
      local_id: undefined,
    });

    navigate("/agendar/horarios");
  }

  return (
    <Layout>
      <BackButton to="/agendar/especialidade" />
      <StepIndicator steps={STEPS} current={4} />

      <div className="fade-up">
        <div className="text-xs uppercase tracking-[0.18em] font-semibold text-[#00357C]">
          {booking.especialidade_nome}
        </div>

        <h1
          className="text-2xl sm:text-3xl tracking-tight font-bold text-slate-900 mt-1"
          style={{ fontFamily: "Manrope" }}
        >
          Selecione o profissional
        </h1>

        {booking.convenio_id ? (
          <p className="text-slate-600 mt-2 text-sm">
            Escolha o profissional desejado para consultar os horários disponíveis
          </p>
        ) : (
          <p className="text-slate-600 mt-2 text-sm">
            Escolha o profissional desejado para consultar os horários disponíveis
          </p>
        )}
      </div>

      {booking.exige_guia && (
        <div className="mt-5 flex items-start gap-2 bg-amber-50 text-amber-800 border border-amber-100 rounded-xl px-4 py-3 text-sm">
          <AlertCircle size={16} className="mt-0.5 shrink-0" />
          <div>{booking.mensagem_guia || "Este convênio exige guia previamente liberada."}</div>
        </div>
      )}

      {items === null ? (
        <Loading label="Buscando profissionais..." />
      ) : items.length === 0 ? (
        <div className="mt-8 text-slate-500 text-sm">
          Nenhum profissional disponível para esta especialidade e tipo de atendimento.
        </div>
      ) : (
        <div className="mt-6 space-y-3 fade-up-stagger" data-testid="profissionais-list">
          {items.map((p) => (
            <button
              key={p.id}
              data-testid={`profissional-${p.id}`}
              onClick={() => handleSelect(p)}
              className="w-full bg-white border border-slate-200 rounded-2xl p-4 text-left hover:-translate-y-0.5 hover:shadow-md transition-all flex items-center gap-4"
            >
              <div className="w-12 h-12 rounded-full bg-[#E6EDF5] text-[#00357C] flex items-center justify-center shrink-0">
                <UserRound size={22} />
              </div>

              <div className="flex-1 min-w-0">
                <div className="font-medium text-slate-900 truncate">{p.nome}</div>
                {p.crm && <div className="text-xs text-slate-500 mt-0.5">CRM {p.crm}</div>}
              </div>

              <ChevronRight size={18} className="text-slate-400" />
            </button>
          ))}
        </div>
      )}
    </Layout>
  );
}